/*
 * 助手相关管理接口
 * */
import services from "../config/axios";
import base from "./base";

const psyManageAPI = {
    // 获取需求列表
    getRobotCronList<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/GetRobotCronList`, params);
    },
    addRobotCron<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/AddRobotCron`, params);
    },
    updateRobotCron<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/UpdateRobotCron`, params);
    },
    getPublishList<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/GetPublishList`, params);
    },
    getRobotCronOne<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/GetRobotCronOne`, params);
    },
    deleteRobotCron<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/DeleteRobotCron`, params);
    },
    updateRobotCronEnabled<T>(params: FormData) {
        return services.post(`${base.lk}/PsyManage/UpdateRobotCronEnabled`, params);
    },
};

export default psyManageAPI;
